export enum GeneralSettingsFields {
  ORGANIZATION = 'organization',
  SUPPORT_EMAIL = 'support_email',
  SUPPORT_PHONE_NUMBER = 'support_phone_number',
}

export type TGeneralSettingsValues = {
  [GeneralSettingsFields.ORGANIZATION]: string;
  [GeneralSettingsFields.SUPPORT_EMAIL]?: string;
  [GeneralSettingsFields.SUPPORT_PHONE_NUMBER]?: string;
};
